import config from 'constants/config'
import React from 'react'
import {
  STEP_BOOK_DATES,
  STEP_CAPACITY,
  STEP_CHANGE_DATES,
  STEP_CHANGE_PACKAGE,
  STEP_DAY_CALENDAR,
  STEP_DEPARTING_FLIGHT,
  STEP_EXPERIENCES,
  STEP_MONTH_CALENDAR,
  STEP_PAYMENT,
  STEP_RETURNING_FLIGHT,
  STEP_TOUR_DATES,
} from 'constants/booking'
import { CompactFooter, OriginalFooter } from 'components/App/Footer'
import { Route, Switch } from 'react-router'
import MinimalFooter from '../Footer/MinimalFooter'
import { LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP } from 'agentHub/routes/AgentHubRoutes'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import styled from 'styled-components'
import { rem } from 'polished'

const ReservedFooterSpace = styled.div`
  /*
      Place space at the bottom to simulate some footer spacing
      This prevents overflow issues where by absolutely positioned elements
      at the bottom of the page MAY overflow the page and a cause a second scrollbar
      Now there is no way to overflow, as there is extra padding.
    */
  height: ${rem(40)};
`

const routesWithNoFooter = [
  `/:regionCode/booking/${STEP_CAPACITY}`,
  `/:regionCode/booking/${STEP_BOOK_DATES}`,
  `/:regionCode/booking/${STEP_CHANGE_DATES}`,
  `/:regionCode/booking/${STEP_CHANGE_PACKAGE}`,
  `/:regionCode/booking/${STEP_MONTH_CALENDAR}`,
  `/:regionCode/booking/${STEP_DAY_CALENDAR}`,
  `/:regionCode/booking/${STEP_DEPARTING_FLIGHT}`,
  `/:regionCode/booking/${STEP_RETURNING_FLIGHT}`,
  `/:regionCode/booking/${STEP_TOUR_DATES}`,
  `/:regionCode/booking/${STEP_EXPERIENCES}`,
  `/:regionCode/booking/${STEP_PAYMENT}`,
  `/:regionCode/bb/booking/${STEP_PAYMENT}`,
  '/:regionCode/account/my-escapes/experiences/:experienceItemId/voucher',
  '/:regionCode/search/map',
  '/:regionCode/search',
  '/:regionCode/metasearch/:propertyId',
  '/:regionCode/search/experiences/map',
  '/:regionCode/gift-card/:code',
  '/:regionCode/travel-protection/quote',
  '/:regionCode/travel-protection/checkout',
  '/:regionCode/checkout',
  '/:regionCode/splashpage',
  '/:regionCode/travel-protection/details',
  '/:regionCode/travel-protection/payment',
  `/:regionCode${LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP}`,
  '/:regionCode/agent-hub/account-setup-completed',
  '/:regionCode/trip-planner/generate-trip',
]

// Use the footer type originally for the checkout page
const routesWithMinimalFooter = [
  '/:regionCode/trip-planner/trip',
  '/:regionCode/trip-planner/public-trip',
  '/:regionCode/pay/:paymentLinkId',
]

const routesWithNoFooterMobileTablet = [
  '/:regionCode/support',
]

function FooterRoutes() {
  const headless = useAppSelector(state => state.system.headlessMode)

  const Footer = config.footer.type === 'original' ? OriginalFooter : CompactFooter
  return (
    <Switch>
      <Route path={routesWithNoFooter} />
      <Route path={routesWithMinimalFooter} component={MinimalFooter} />
      <Route path={routesWithNoFooterMobileTablet}>
        <CSSBreakpoint min="desktop">
          <Footer />
        </CSSBreakpoint>
      </Route>
      <Route exact path="/:regionCode/" component={Footer} />
      <Route>
        {headless && <ReservedFooterSpace aria-hidden="true" />}
        {!headless && <Footer />}
      </Route>
    </Switch>
  )
}

export default FooterRoutes
